export default "__VITE_ASSET__BTbh12Od__"